import { Roles } from "../bundles/enums.bundle";

export class PermissionHelper {
    constructor(private readonly roleId: number) { }

    get superAdmin() {
        return [Roles.SuperAdmin].indexOf(this.roleId) > -1;
    }

    get system() {
        return [Roles.SuperAdmin, Roles.SystemManager, Roles.SystemUser].indexOf(this.roleId) > -1;
    }

    get admin() {
        return [Roles.SuperAdmin, Roles.SystemManager].indexOf(this.roleId) > -1;
    }

    get client() {
        return [Roles.ClientManager, Roles.Manager, Roles.ClientUser, Roles.User, Roles.Abstractor].indexOf(this.roleId) > -1;
    }

    get user() {
        return [Roles.Manager, Roles.ClientUser, Roles.User].indexOf(this.roleId) > -1;
    }

    get systemManager() {
        return [Roles.SuperAdmin, Roles.SystemManager].indexOf(this.roleId) > -1;
    }

    get clientManager() {
        return [Roles.SuperAdmin, Roles.SystemManager, Roles.SystemUser, Roles.ClientManager, Roles.Abstractor].indexOf(this.roleId) > -1;
    }
    get systemUser() {
        return [Roles.SuperAdmin, Roles.SystemManager, Roles.SystemUser, Roles.ClientManager, Roles.Manager, Roles.Abstractor].indexOf(this.roleId) > -1;
    }
    get manager() {
        return [Roles.SuperAdmin, Roles.SystemManager, Roles.ClientManager, Roles.Manager].indexOf(this.roleId) > -1;
    }

    get clientLayout() {
        return [Roles.ClientManager, Roles.Manager].indexOf(this.roleId) > -1;
    }

    get clientManagerManager() {
        return [Roles.SuperAdmin, Roles.SystemManager, Roles.ClientManager, Roles.Abstractor].indexOf(this.roleId) > -1;
    }

    get enterpriseAdmin() {
        return [Roles.SuperAdmin, Roles.ClientManager, Roles.Abstractor].indexOf(this.roleId) > -1;
    }

    get all() {
        return [Roles.SystemUser, Roles.SystemManager, Roles.ClientUser, Roles.Manager, Roles.User, Roles.Abstractor].indexOf(this.roleId) > -1;
    }

    get unassignedUser() {
        return [Roles.UnassignedUser].indexOf(this.roleId) > -1;
    }

    // vpat used in side bar component to get the focus when we press enter
    get userOnly() {
        return [Roles.User].indexOf(this.roleId) > -1;
    }

    // To show the New Dashboard.
    get dashboard() {
        return [Roles.ClientManager, Roles.ClientUser, Roles.Manager].indexOf(this.roleId) > -1;
    }

    get abtsractorUser() {
        return [Roles.Abstractor, Roles.User].indexOf(this.roleId) > -1;
    }
}